"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var constructableStylesheetsSupported = typeof window !== 'undefined' && window.ShadowRoot && window.ShadowRoot.prototype.hasOwnProperty('adoptedStyleSheets') && window.CSSStyleSheet && window.CSSStyleSheet.prototype.hasOwnProperty('replace');
var shadowRootSupported = typeof window !== 'undefined' && window.Element && window.Element.prototype.hasOwnProperty('attachShadow');

var _default = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(_default, _React$PureComponent);

  var _super = _createSuper(_default);

  /**
   * @param {object} props Properties passed to the component
   * @param {boolean} props.declarative  When true, uses a declarative shadow root
   * @param {boolean} props.delegatesFocus  Expands the focus behavior of elements within the shadow DOM.
   * @param {string} props.mode Sets the mode of the shadow root. (open or closed)
   * @param {CSSStyleSheet[]} props.stylesheets Takes an array of CSSStyleSheet objects for constructable stylesheets.
   */
  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      initialized: false
    });

    _this.placeholder = _react["default"].createRef();
    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          delegatesFocus = _this$props.delegatesFocus,
          mode = _this$props.mode,
          stylesheets = _this$props.stylesheets;
      this.shadowRoot = this.placeholder.current.parentNode.attachShadow({
        delegatesFocus: delegatesFocus,
        mode: mode
      });

      if (stylesheets) {
        this.shadowRoot.adoptedStyleSheets = stylesheets;
      }

      this.setState({
        initialized: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.initialized) {
        if (this.props.declarative) {
          // @ts-ignore
          return /*#__PURE__*/_react["default"].createElement("template", {
            ref: this.placeholder,
            shadowroot: this.props.mode
          }, this.props.children);
        }

        return /*#__PURE__*/_react["default"].createElement("span", {
          ref: this.placeholder
        });
      }

      return _reactDom["default"].createPortal(this.props.children, this.shadowRoot);
    }
  }]);

  return _default;
}(_react["default"].PureComponent);

exports["default"] = _default;

_defineProperty(_default, "constructableStylesheetsSupported", constructableStylesheetsSupported);

_defineProperty(_default, "constructibleStylesheetsSupported", constructableStylesheetsSupported);

_defineProperty(_default, "defaultProps", {
  declarative: false,
  delegatesFocus: false,
  mode: 'open'
});

_defineProperty(_default, "displayName", 'ReactShadowRoot');

_defineProperty(_default, "propTypes", {
  declarative: _propTypes["default"].bool,
  delegatesFocus: _propTypes["default"].bool,
  mode: _propTypes["default"].oneOf(['open', 'closed']),
  stylesheets: _propTypes["default"].arrayOf(typeof window !== 'undefined' ? _propTypes["default"].instanceOf(window.CSSStyleSheet) : _propTypes["default"].any)
});

_defineProperty(_default, "shadowRootSupported", shadowRootSupported);